module.exports = __webpack_public_path__ + "img/imgImgHomeLB01.081161e2.svg";